<template>
    <div class="relative bg-wrap-color">
        <template v-if="isPageAllowed">
            <div style="transition: none;" v-show="componentName != 'CreatePage'">
                <div class="tab-bar relative">
                    <el-tabs v-model="activeTabName" @tab-click="changeTab">
                        <el-tab-pane label="托管规则" name="intelligent_managed_rule" v-if="pageActionNames.includes('intelligent_managed_rule')"></el-tab-pane>
                        <el-tab-pane label="运行记录" name="intelligent_managed_run_record" v-if="pageActionNames.includes('intelligent_managed_run_record')"></el-tab-pane>
                        <el-tab-pane label="触发记录" name="intelligent_managed_trigger_record" v-if="pageActionNames.includes('intelligent_managed_trigger_record')"></el-tab-pane>
                    </el-tabs>
                </div>
            </div>

            <div class="pl10 pr10 pb10">
                 <transition name="fade" mode="out-in">
                    <keep-alive :include="keepList">
                        <component
                        :is="componentName"
                        @create="showCreatePage"
                        @changePage="handleChangePage"
                        @close="handleCreateClose"
                        :pageFuncNames="tabFuncNames"
                        :allowed-plat-list="allowedPlatList"
                        :query="query"
                        :reload.sync="reload"
                        :data="actionData"
                        :type="actionType"
                        />
                    </keep-alive>
                </transition>
            </div>

            <!-- <CreatePage v-if="create_show" :plat-list="allowedPlatList" ref="createAds" @close="handleCreateClose"></CreatePage> -->
        </template>
        <template v-else>
            <NoPermissionInfo>
                <p>智能托管页面</p>
            </NoPermissionInfo>
        </template>
    </div>
</template>

<script>
    import {pageMixin} from '../../mixins/pageMixin';
    import NoPermissionInfo from '@/components/noPermissionInfo';
    import RulePage from './page/rulePage';
    import RunRecordPage from './page/runRecordPage';
    import TriggerRecordPage from './page/triggerRecordPage';
    import CreatePage from './page/create';
    import {undistributeMixin} from '../../mixins/undistributeMixin';



    export default {
        name: "IntelligentManagedIndex",
        mixins: [pageMixin,undistributeMixin],
        components:{
            NoPermissionInfo,
            RulePage,
            RunRecordPage,
            TriggerRecordPage,
            CreatePage,
        },
        data(){
            return {
                create_show: true,  //创建页面
                activeTabName:'intelligent_managed_rule',
                componentName: 'RulePage',
                keepList:['RulePage'],
                query: {}, //传入对象
                reload: '', //更新接口
                actionData:{},
                actionType:'',

            }
        },
        provide(){
            return {
                pageAction: () => this.pageAction,
                pageFunc: () => this.pageFunc,
            }
        },
        computed:{
            pageActionNames(){
                return this.pageAction.map(item=>item.name);
            },
            tabFunc(){
                let actionTab = (this.pageAction||[]).find(item=>item.name==this.activeTabName);
                if(actionTab){
                    return actionTab.func||[];
                }
                return [];
            },
            tabFuncNames(){
                return (this.tabFunc||[]).map(item=>item.name);
            },
        },
        mounted(){
            // this.initPageStates()
        },
        methods:{
            initPageStates(){
                let url_params = this.$route.query
                if(url_params['url'] == 'TriggerRecordPage') {
                    this.handleChangePage('TriggerRecordPage', {id:url_params['id'] ? url_params['id'] : '', range_time: url_params['range_time'] ? url_params['range_time'] : []})
                }
            },
            showCreatePage(){
                this.create_show = true;
            },
            changeTab(tab){
                this.query = {}
                if(this.activeTabName == 'intelligent_managed_rule') {
                    this.componentName = 'RulePage'
                    this.keepList = ['RulePage']
                }else if(this.activeTabName == 'intelligent_managed_run_record') {
                    this.componentName = 'RunRecordPage'
                    this.keepList = [];
                }else if(this.activeTabName == 'intelligent_managed_trigger_record') {
                    this.componentName = 'TriggerRecordPage'
                    this.keepList = [];
                }
                // this.$nextTick(()=>{
                //     this.keepList = [];
                // })
            },
            handleCreateClose(){
                this.create_show = false;
            },
            handleChangePage(url, params,type) {
                console.log('params', params)
                if(url == 'RunRecordPage') {
                    this.activeTabName = 'intelligent_managed_run_record'
                    this.componentName = url
                    this.query = params
                    this.keepList = []
                }else if(url == 'TriggerRecordPage') {
                    this.activeTabName = 'intelligent_managed_trigger_record'
                    this.componentName = url
                    this.query = params
                    this.keepList = []
                }else if(url == 'RulePage'){
                    this.activeTabName = 'intelligent_managed_rule'
                    this.componentName = url;
                    this.keepList = ['RulePage']
                    if(type=='create'){
                        this.$nextTick(()=>{
                            console.log('创建更新 up', type);
                            this.reload = type
                        })
                    }else if(type=='edit'){
                        this.$nextTick(()=>{
                            console.log('编辑更新 up', type);
                            this.reload = type
                        })
                    }
                }else if(url == 'CreatePage') {
                    this.actionData = params;
                    this.actionType = type;
                    this.componentName = url;
                    this.keepList = ['RulePage']
                    this.$nextTick(()=>{
                        console.log('更新列表数据');
                        this.reload = ''
                    })
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    .tab-bar::after{
        content: '';
        position: absolute;
        left: -20px;
        right: -20px;
        background-color: #fff;
    }
    .tab-bar ::v-deep .el-tabs__header{
        background-color: #fff;
        margin-bottom: 10px;
        .el-tabs__nav-wrap{
            padding-left: 30px;
        }
    }
    .tab-bar ::v-deep .el-tab-pane{
        margin: 0 15px;
    }
    .bg-wrap-color{
        padding: 0;
        background-color:#F1F4F9;
    }
</style>
